import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { CommissionCharge } from "../../../Common/AdviserCharges/Components/CommissionCharge";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { RIAC } from "../../../Common/AdviserCharges/Components/RIAC";
import { AdviserChargesContents } from "../../../Common/AdviserCharges/Resource/Contents";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { RegularPaymentActionType } from "../../Resource/Contents";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";

interface IAdviserChargesProps extends IProcessComponentProps {
    type: SubAccountType;
}

interface IAdviserChargesState {}

export class AdviserCharges extends ProcessComponent<IAdviserChargesProps, IAdviserChargesState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    public render(): JSX.Element {
        const { type } = this.props;
        const processType =
            getQueryParameters()["action"] === RegularPaymentActionType.Edit
                ? ProcessType.EditRegular
                : ProcessType.AddRegular;
        return (
            <>
                <h2>{AdviserChargesContents.AcHeader}</h2>

                <h3 className="heading-underlined">{AdviserChargesContents.ProductLevel}</h3>

                {SubAccountTypeHelper.isOnPlatformPension(type) && (
                    <RIAC type={this.props.type} {...this.getProps("Contribution")} />
                )}

                <OAC existingAccount={true} type={this.props.type} {...this.getProps("Contribution")} />

                <CommissionCharge
                    {...this.getProps("Contribution")}
                    processType={processType}
                    headAccountHierarchyId={getQueryParameters()["hierarchyid"]}
                />

                <ChargesOnIllustration {...this.getProps("Contribution")} />
            </>
        );
    }
}
